import type {
  ApiErrorResponse,
  HealthResponse,
  TourDetailResponse,
  TourMonth,
  TourSearchRequest,
  TourSearchResponse,
} from "../../src/shared/contracts";

const isApiError = (value: unknown): value is ApiErrorResponse =>
  Boolean(
    value &&
      typeof value === "object" &&
      "message" in value &&
      typeof (value as ApiErrorResponse).message === "string"
  );

const fetchJson = async <T>(input: RequestInfo, init?: RequestInit): Promise<T> => {
  const response = await fetch(input, init);

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as unknown;
    const message = isApiError(body) ? body.message : `Request failed with status ${response.status}`;

    throw new Error(message);
  }

  return response.json() as Promise<T>;
};

export const getHealth = () => fetchJson<HealthResponse>("/api/health");

export const getTourMonths = () => fetchJson<TourMonth[]>("/api/tour-months");

export const searchTour = (payload: TourSearchRequest) =>
  fetchJson<TourSearchResponse>("/api/tours/search", {
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
  });

export const getTourDetail = (sheetSlug: string, code: string, token: string) =>
  fetchJson<TourDetailResponse>(
    `/api/tours/${encodeURIComponent(sheetSlug)}/${encodeURIComponent(code)}/${encodeURIComponent(token)}`
  );
